import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch a single cost center by its code.
 * @param {string} cc - The cost center code to look up.
 * @returns {object} Cost center query result with data, loading, success, and error states.
 */
export const useCostCenter = (cc) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_COST_CENTER, cc],
    // @ts-ignore
    queryFn: () => api.invMgmt.getCostCenter({ cc }),
    enabled: apiReady && Boolean(cc),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    costCenter: data,
    costCenterIsLoading: isLoading,
    costCenterIsSuccess: isSuccess,
    costCenterIsError: isError,
    costCenterError: error,
  };
};
